var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from '../axiosv2';
export const getAccount = (accountId) => {
    return axios
        .get(`/v2/account/${accountId}`)
        .then(({ data }) => Promise.resolve(data))
        .catch(error => {
        return Promise.reject(error.response.data);
    });
};
export const getAccountWithToken = (accountId, token) => {
    return axios
        .get(`/v2/account/${accountId}`, {
        headers: {
            Authorization: token,
        },
    })
        .then(({ data }) => Promise.resolve(data))
        .catch(error => {
        return Promise.reject(error.response.data);
    });
};
export const getCustomBranding = (accountId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { data } = yield axios.get('/v2/branding', { params: { accountId } });
        return data.branding || {};
    }
    catch (error) {
        return {};
    }
});
